import { render } from "./home.vue?vue&type=template&id=aaac50c8&scoped=true"
import script from "./home.vue?vue&type=script&lang=js"
export * from "./home.vue?vue&type=script&lang=js"

import "./home.vue?vue&type=style&index=0&id=aaac50c8&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-aaac50c8"

export default script